module.exports = __webpack_public_path__ + "static/img/ZQ.bb054a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZQ.png
// module id = Zr5Z
// module chunks = 34